import React from 'react';
import { XIcon } from 'lucide-react';
import { Container } from './Container';
import { painItems } from '../data/landing';
export function PainSection() {
  return <section aria-labelledby="pain-title" className="bg-white py-16 sm:py-20 lg:py-24" data-id="element-264" data-mp="38vkeocenfju7">
      <Container data-id="element-265" data-mp="2v08evqlmz36f">
        <div className="grid gap-10 lg:grid-cols-[0.95fr_1.05fr] lg:gap-16" data-id="element-266" data-mp="2yzqymj1q187o">
          <div data-id="element-267" data-mp="2z1tsxf9wpni7">
            <h2 id="pain-title" className="text-balance font-heading text-[2rem] font-black leading-[1.08] tracking-[-0.01em] text-navy sm:text-4xl lg:text-[2.9rem]" data-id="element-268" data-mp="2l8cda5kccuxg">
              ¿Cuántas noches más pensando qué mandar mañana?
            </h2>
            <p className="mt-5 text-base leading-relaxed text-navy-soft sm:text-lg" data-id="element-269" data-mp="2b8bquar6dyp1">
              Terminás el día, por fin te sentás… y aparece la pregunta. Abrís la heladera, mirás lo que hay y resolvés con lo primero que sale.
            </p>
            <p className="mt-6 rounded-2xl bg-teal-light/50 px-5 py-4 font-heading text-xl font-extrabold leading-snug text-navy sm:text-2xl" data-id="element-270" data-mp="277jev9qx5fp2">
              No te faltan recetas. <span className="text-teal-dark" data-id="element-271" data-mp="3nlfic2v98lyk">Te falta un sistema.</span>
            </p>
          </div>

          <ul className="divide-y divide-teal-soft rounded-3xl border border-teal-soft bg-cream px-5 sm:px-7" data-id="element-272" data-mp="5fke4xchfu34">
            {painItems.map(item => <li key={item} className="flex items-start gap-4 py-4 sm:py-5" data-id="element-273" data-mp="h98yzx4u7r8">
                <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-pink-light" data-id="element-274" data-mp="38xkouk9fadkf">
                  <XIcon aria-hidden="true" strokeWidth={3} className="h-4 w-4 text-pink" data-id="element-275" data-mp="33z11qgj3evqh" />
                </span>
                <span className="text-base leading-relaxed text-navy sm:text-[17px]" data-id="element-276" data-mp="3iofgk45fu5d9">{item}</span>
              </li>)}
          </ul>
        </div>

        <p className="mx-auto mt-14 max-w-3xl text-balance text-center font-heading text-2xl font-black leading-snug text-navy sm:text-[2rem]" data-id="element-277" data-mp="2q5027kkbh4p2">
          ¿Y si esta fuera la última noche que lo resolvés <span className="text-pink" data-id="element-278" data-mp="p4lmwtpguktb">a último momento</span>?
        </p>
      </Container>
    </section>;
}